import { DividerContainer } from "./style";

export function Divider() {
  return <DividerContainer />
}